module.exports = __webpack_public_path__ + "static/js/1c7c272eddb12e4592405121f163cc78.js";